import moment from 'moment';
import { ISO_DATE_FORMAT } from 'utils/constants';
import {
	ILimitPerClient,
	IPartnerDataPayload,
	IPartnerFormData,
} from '../models';

export function mapPartnerPayload(data: IPartnerFormData): IPartnerDataPayload {
	const {
		partnerId,
		contractStartDate,
		contractEndDate,
		contractData,
		shortName,
		formalName,
		logoData,
		website,
		comment,
		surveyLimitPerClientDtos,
		clientCountLimit,
		adminCountLimit,
		partnerUserCountLimit,
		surveyCountLimit,
		surveyPerClientLimitList,
		primaryColor,
		useOptionalHeaderLogo,
		optionalHeaderLogoData,
	} = data;

	return {
		partnerId,
		clientCountLimit: clientCountLimit
			? parseInt(clientCountLimit, 10)
			: undefined,
		adminCountLimit: adminCountLimit
			? parseInt(adminCountLimit, 10)
			: undefined,
		partnerUserCountLimit: partnerUserCountLimit
			? parseInt(partnerUserCountLimit, 10)
			: undefined,
		surveyCountLimit: surveyCountLimit
			? parseInt(surveyCountLimit, 10)
			: undefined,
		shortName,
		formalName,
		contractDto: {
			startDate: moment(contractStartDate).format(ISO_DATE_FORMAT),
			endDate: moment(contractEndDate).format(ISO_DATE_FORMAT),
			fileKey: contractData?.fileKey as string,
		},
		logoKey: logoData.fileKey,
		website,
		comment,
		limitPerClientDtos: limitsToArray(
			surveyPerClientLimitList,
			surveyLimitPerClientDtos,
		),
		primaryColor,
		useAdditionalLogo: useOptionalHeaderLogo,
		additionalLogoFileKey: useOptionalHeaderLogo
			? optionalHeaderLogoData.fileKey
			: null,
		additionalLogoUrl: useOptionalHeaderLogo
			? optionalHeaderLogoData.publicUrl
			: null,
	};
}

function limitsToArray(limitList: ILimitPerClient[], limit?: string) {
	return limit ? [...limitList, { limit: parseInt(limit, 10) }] : limitList;
}
